import { render, staticRenderFns } from "./rjcpzx3.vue?vue&type=template&id=efd66374&scoped=true&"
import script from "./rjcpzx3.vue?vue&type=script&lang=js&"
export * from "./rjcpzx3.vue?vue&type=script&lang=js&"
import style0 from "./rjcpzx3.vue?vue&type=style&index=0&id=efd66374&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd66374",
  null
  
)

export default component.exports